import React from 'react'
import PropTypes from 'prop-types'

import { isSuperUser } from 'utils/Auth'

import Styles from './index.scss'

const AddDataButton = (props) => {
  if (isSuperUser(props.user)) {
    return (
      <button
        className={`btn-add-item ${props.disabled ? Styles.disabled : ''}`}
        onClick={props.actions}
        disabled={props.disabled}
      >
        {props.label}
      </button>
    )
  }
  return (
    <div />
  )
}

AddDataButton.defaultProps = {
  actions: () => { },
  label: '',
  user: {
    email: '',
  },
  disabled: false,
}

AddDataButton.propTypes = {
  actions: PropTypes.func,
  label: PropTypes.string,
  user: PropTypes.shape({
    email: PropTypes.string,
  }),
  disabled: PropTypes.bool,
}

export default AddDataButton
